import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ROUTES } from 'routes/routes';

import NavigationTabs, {
  NavigationTab,
} from 'components/NavigationTabs/NavigationTabs';

import style from './FeedbackReportPage.module.scss';
import FeedbackReportTab from './Tabs/FeedbackReportTab/FeedbackReportTab';
import FeedbackDishGroupsReportTab from './Tabs/FeedbackDishGroupsReportTab/FeedbackDishGroupsReportTab';

class FeedbackReportPage extends Component {
  tabs: NavigationTab[] = [
    { to: ROUTES.admin.feedback, title: 'title.report.feedback.tab1' },
    { to: ROUTES.admin.feedbackMenuItems, title: 'title.report.feedback.tab2' },
  ];

  render() {
    return (
      <div className={style.main}>
        <NavigationTabs className={style.tabs} tabs={this.tabs} />

        <Switch>
          <Route
            path={ROUTES.admin.feedback}
            component={FeedbackReportTab}
            exact
          />

          <Route
            path={ROUTES.admin.feedbackMenuItems}
            component={FeedbackDishGroupsReportTab}
            exact
          />

          <Redirect to={ROUTES.admin.feedback} />
        </Switch>
      </div>
    );
  }
}

export default FeedbackReportPage;
